import React, {Component} from "react";
import {Button, Form, Input, Spin, Card, Modal} from 'antd';
import {Icon} from "@ant-design/compatible"
import axios from "axios";
//import {browserHistory} from "react-router";
import { connect } from 'react-redux';
import {SolutionOutlined} from "@ant-design/icons";
import {LOGIN, LOGOUT, RESET_LOGIN_REPEAT} from "reducers/authenticationNew";
const FormItem = Form.Item;

class LoginWithMobileModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      validationCodeSent: false,
      validationCodeTimeLeft: 120, // seconds
      submitError: false,
      phoneInfo:""
    }
  }

  componentDidMount(){

    // this.sendValidationCode();
  }

  componentWillUpdate(nextProps) {
    if ((nextProps.isAlreadyLoginSomewhere !== this.props.isAlreadyLoginSomewhere)&&(nextProps.isAlreadyLoginSomewhere===true)) {

      axios.get("/login-validate/getPhoneInfo",{contentType: "application/json"}).then(
        response => {
          this.setState({
            phoneInfo:response.data
          })
        }
      );
    }
  }

  componentWillUnmount(){
    clearInterval(this.timer);
  }

  sendValidationCode = () => {
    axios({
      url: `/login-validate/mobileLoginVerificationCodes`,
      method: "GET"
    }).then(
      response => {
        console.log("response", response.data);
        if (response.status === 200) {
          this.timer = setInterval(() => this.tick(), 1000);
          this.setState({
            validationCodeSent: true,
            validationCodeTimeLeft: 120
          })
        }
      }
    ).catch(
      err => {
        console.log("ERROR: failed to get validation code");
      }
    )
  };

  tick = () => {
    let count = this.state.validationCodeTimeLeft > 0 ? this.state.validationCodeTimeLeft - 1 : 0;
    this.setState({
      validationCodeTimeLeft: count
    });

    if (count === 0) {
      this.setState({
        validationCodeSent: false
      });
      clearInterval(this.timer)
    }
  };

  handleSubmit = (values) =>{
      axios({
        url: `/validateCode/${values.code}`,
        method: "POST"
      }).then(
        response => {
          this.props.reset();
          // history.push("/")
          this.props.getLoginInfo();
        },
      ).catch(
        err => {
          Modal.error({
            title: '验证码错误',
            // title: '重置密码失败',
            content: err.data,
          })
        })
  };

  finishFailed = (errorInfo) => {
    console.log("Error: validation failed: ", errorInfo);
  }

  deleteCookie=()=>{
    // axios.get("/delete-self-session").then(
    //   response => {
    //     // window.location.href="/"
    //     this.props.reset();
    //     browserHistory.push("/")
    //   }
    // )
    this.props.handleLogout();
    this.props.reset();
    this.props.history.push("/")
  };

  render(){
    //const {getFieldDecorator} = this.props.form;
    let validationCodeBtn = (
      <Button
        type="primary"
        style={{width: "50%"}}
        // disabled={!/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(this.props.form.getFieldValue("phone"))}
        onClick={this.sendValidationCode}
      >
        获取验证码
      </Button>
    );
    if (this.state.validationCodeSent) {
      validationCodeBtn = (
        <Button
          type="primary"
          style={{width: "100%"}}
          disabled
        >
          {`${this.state.validationCodeTimeLeft}`}秒后点击重新发送
        </Button>
      )
    }
    return(
      <Modal
        title="手机登录验证"
        visible={this.props.isAlreadyLoginSomewhere}
        footer={null}
        style={{paddingBottom:0}}
        closable={false}
      >
      {/*<Card title="验证手机号" style={{margin:"0 auto",width:500,marginTop:100,marginBottom:50, boxShadow:"0 2px 15px rgba(0,0,0,.15)",backgroundColor:"white"}}>*/}
        <div style={{align:"center",marginBottom:"16px",fontSize:13}}><scan>当前用户已在其他客户端登录，点击发送验证码到尾号<strong>{this.state.phoneInfo}</strong>的手机上进行手机验证</scan></div>
        <Form layout="inline" onFinish={this.handleSubmit} onFinishFailed={this.finishFailed}>
          <FormItem name={"code"} rules={[{required: true, message: "请输入验证码"}]} style={{width: '100%'}}>
            <div style={{display: "flex", width: '100%'}}>
              <Input
                style={{marginRight: "16px"}}
                prefix={<SolutionOutlined
                  style={{color: 'rgba(0,0,0,.25)'}}/>}
                placeholder="验证码"
              />
              {validationCodeBtn}
            </div>
          </FormItem>
          <FormItem style={{marginBottom:10, marginTop: 10, width: '100%'}} >
            <div style={{display:"flex"}}>
              <Button style={{width: "50%",marginRight:20}} onClick={this.deleteCookie}>取消</Button>
              <Button type="primary" htmlType="submit" style={{width: "50%"}}>确定</Button>
            </div>
          </FormItem>
        </Form>

      {/*</Card>*/}
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    reset:()=>{
      dispatch({type: RESET_LOGIN_REPEAT});
    },
    getLoginInfo:()=>{
      dispatch({type:LOGIN});
    },
    handleLogout:()=>{
      dispatch({type:LOGOUT});
    }
  };
};

export default connect(
  state => ({
    isAlreadyLoginSomewhere: state.authentication.isAlreadyLoginSomewhere
  }),
  mapDispatchToProps
)(LoginWithMobileModal);
// export default Form.create()(LoginWithMobileModal);
